import { AutogenModelEmailProfile, AutogenRowEmailProfile } from "./autogen/AutogenModelEmailProfile";

export class ModelEmailProfile extends AutogenModelEmailProfile<RowEmailProfile> {
	constructor() {
		super(RowEmailProfile);
	}
}

export class RowEmailProfile extends AutogenRowEmailProfile {
}